// import React from 'react';

function Layout(props) {
    return props.children;
}

export default Layout;
